import { render, staticRenderFns } from "./AlterNotice.vue?vue&type=template&id=5f016ea8&scoped=true&"
import script from "./AlterNotice.vue?vue&type=script&lang=js&"
export * from "./AlterNotice.vue?vue&type=script&lang=js&"
import style0 from "./AlterNotice.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AlterNotice.vue?vue&type=style&index=1&id=5f016ea8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f016ea8",
  null
  
)

export default component.exports